/**
 * Normalizes a list of phone numbers by splitting entries that contain multiple
 * numbers separated by `" / "` and trimming each resulting number.
 *
 * Examples:
 * - ["A / B", "C"] → ["A", "B", "C"]
 *
 * If `phoneNumbers` is null or undefined, returns an empty array.
 */
export const formatPhoneNumbersToArray = (phoneNumbers) => {
    var _a;
    return (_a = phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.flatMap((number) => number.includes(" / ") ? number.split(" / ").map((n) => n.trim()) : [number])) !== null && _a !== void 0 ? _a : [];
};
